import { Injectable, inject } from '@angular/core';
import { Store, select } from '@ngrx/store';
import { filter, map, Observable, withLatestFrom } from 'rxjs';
import {
  getAlternatesList,
  isAlternatesDataLoading,
} from '../selectors/boels-alternates.selectors';
import {
  BoelsAlternateList,
  BoelsAlternatesState,
} from '../reducers/boels-alternates.reducers';
import { LoadAlternates } from '../actions/boels-alternates.actions';
import * as fromSelector from '../selectors/boels-alternates.selectors';
import { Alternate } from '@boels/models';

@Injectable()
export class BoelsAlternatesFacade {
  private readonly store = inject(Store);

  get(): Observable<BoelsAlternatesState> {
    return this.store.pipe(select(fromSelector.getAlternatesState));
  }

  loadAlternates(categoryId: string) {
    this.store.dispatch(new LoadAlternates({ categoryId }));
  }

  getAlternates(): Observable<BoelsAlternateList> {
    return this.store.pipe(select(getAlternatesList));
  }

  getByCategoryId(categoryId: string): Observable<Alternate[]> {
    return this.getAlternates().pipe(
      withLatestFrom(this.store.pipe(select(isAlternatesDataLoading))),
      filter((alternatesState) => !alternatesState[1]),
      map(([alternates]) => alternates[categoryId]),
    );
  }
}
